import { useState } from "react";
import { useLocation } from "react-router-dom";
import { openTelegramLink } from "@telegram-apps/sdk";
import { ChevronRight } from "lucide-react";
import { EXTERNAL_URLS } from "@shared/configs/externalUrls";
import { SupportIcon } from "@boundary/components/mapIcons";
import { PrefetchLink } from "@boundary/components/prefetchLink";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@boundary/components/dialog";
import { BackgroundImage } from "@boundary/components/backgroundImage";
import styles from "./mapActionCard.module.scss";

interface FiltersModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function FiltersModal({ isOpen, onClose }: FiltersModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className={styles.filtersModalContent}>
        <DialogHeader>
          <DialogTitle className={styles.filtersModalTitle}>
            Фильтр услуг
          </DialogTitle>
          <DialogDescription className={styles.filtersModalDescription}>
            Фильтры временно отключены, так как у нас пока только один аппарат. Когда их станет больше, фильтры помогут быстро найти нужный!
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

function OnboardingCard() {
  const location = useLocation();
  // Получаем текущий путь для возврата после onboarding
  const returnTo = location.pathname || "/map";
  
  return (
    <PrefetchLink 
      to="/onboarding" 
      state={{ returnTo }}
      className={styles.onboardingCard}
    >
      <p className={styles.onboardingTitle}>Как это работает?</p>
      <span className={styles.onboardingSubtitle}>Инструкция</span>
    </PrefetchLink>
  );
}

interface FiltersButtonProps {
  onClick: () => void;
}

function FiltersButton({ onClick }: FiltersButtonProps) {
  return (
    <button 
      onClick={() => {
        console.log(`[Button Click] MapActionCard: "Фильтр услуг"`);
        onClick();
      }} 
      className={styles.filtersButton}
    >
      <p className={styles.filtersButtonText}>
        Фильтр<br />услуг
      </p>
      <img
        src="/assets/printerSm.png"
        alt=""
        className={styles.filtersButtonImage}
      />
    </button>
  );
}

function SupportButton() {
  const handleClick = () => {
    console.log(`[Button Click] MapActionCard: "Связаться с поддержкой"`);
    openTelegramLink(EXTERNAL_URLS.BOT);
  };

  return (
    <button onClick={handleClick} className={styles.supportButton}>
      <SupportIcon />
      <span>Связаться с поддержкой</span>
      <ChevronRight className={styles.supportButtonIcon} />
    </button>
  );
}

export function MapActionCard() {
  const [showFilters, setShowFilters] = useState(false);

  const handleCloseFilters = () => {
    setShowFilters(false);
  };

  return (
    <>
      <FiltersModal isOpen={showFilters} onClose={handleCloseFilters} />
      
      <div className={styles.container}>
        <BackgroundImage radial className={styles.containerBackgroundImage} />
        <div className={styles.content}>
          <OnboardingCard />
          <FiltersButton onClick={() => setShowFilters(true)} />
          <SupportButton />
        </div>
      </div>
    </>
  );
}

